// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "slider-3Dcan";
export { _1 as "__esModule", _2 as "slider" }
export default { "__esModule": _1, "slider": _2 }
